// サーバ側のコード
// https://github.com/Liquid-dev/liquid-ekyc-platform/blob/main/app/domain/entities/id_doc_type.go

enum IdDocType {
  Unknown = 0,
  DriversLicenseHo = 1,
  DriversLicenseTo = 21,
  DriversLicenseTi = 31,
  MyNumberCardHo = 2,
  MyNumberCardTo = 22,
  MyNumberCardTi = 32,
  ResidenceCardHo = 3,
  ResidenceCardTo = 23,
  ResidenceCardTi = 33,
  PassportHo = 4,
  PassportTo = 24,
  PassportTi = 34,
  SpecialPermanentResidentCertificateHo = 5,
  SpecialPermanentResidentCertificateTo = 25,
  SpecialPermanentResidentCertificateTi = 35,
  DrivingHistoryCertificateHo = 6,
  DrivingHistoryCertificateTo = 26,
  DrivingHistoryCertificateTi = 36,
  HealthInsuranceCardTo = 27,
  HealthInsuranceCardTi = 37,
  PhysicalDisabilityCertificateBookTo = 28,
  PhysicalDisabilityCertificateCardTo = 29,
  SpecialEducationBookTo = 2010,
  SpecialEducationCardTo = 2011,
  MentalDisabilityCertificateBookTo = 2012,
  MentalDisabilityCertificateCardTo = 2013,
  PensionBookTo = 2014,
  BasicPensionNumberNotificationTo = 2015,
  PassportAnyIssuanceDateTo = 2016,
  BasicResidentRegistrationCardTo = 2017,
  StudentIDCardTo = 2018,
  StudentNotebookTo = 2019,
  PhysicalDisabilityCertificateBookTi = 38,
  PhysicalDisabilityCertificateCardTi = 39,
  SpecialEducationBookTi = 3010,
  SpecialEducationCardTi = 3011,
  MentalDisabilityCertificateBookTi = 3012,
  MentalDisabilityCertificateCardTi = 3013,
  PensionBookTi = 3014,
  BasicPensionNumberNotificationTi = 3015,
  PassportAnyIssuanceDateTi = 3016,
  BasicResidentRegistrationCardTi = 3017,
  StudentIDCardTi = 3018,
  StudentNotebookTi = 3019,
  MnGeneral = 90,
  GpGeneral = 91,
  MyNumberCardAndBack = 10022,
  DriversLicenseGlobalFace = 11001,
  NationalIdentityCardGlobalFace = 11002,
  ResidenceCardGlobalFace = 11003,
  PassportGlobalFace = 11004,
  PhilIDGlobalFace = 11101,
  TINIDGlobalFace = 11102,
  SSSIDGlobalFace = 11103,
  UMIDGlobalFace = 11104,
  UMID2GlobalFace = 11105,
  NRICGlobalFace = 11106,
  WorkPermitGlobalFace = 11107,
  KTPGlobalFace = 11108,
  KIAOver5GlobalFace = 11109,
  KITAPGlobalFace = 11111,
  CCCDGlobalFace = 11112,
  CMNDGlobalFace = 11113,
  MyPRGlobalFace = 11114,
  MyKADGlobalFace = 11115,
  AadhaarGlobalFace = 11116,
  DriversLicenseGlobalNoFace = 12001,
  NationalIdentityCardGlobalNoFace = 12002,
  ResidenceCardGlobalNoFace = 12003,
  PassportGlobalNoFace = 12004,
  PhilIDGlobalNoFace = 12101,
  TINIDGlobalNoFace = 12102,
  SSSIDGlobalNoFace = 12103,
  UMIDGlobalNoFace = 12104,
  UMID2GlobalNoFace = 12105,
  NRICGlobalNoFace = 12106,
  WorkPermitGlobalNoFace = 12107,
  KTPGlobalNoFace = 12108,
  KIAOver5GlobalNoFace = 12109,
  KIAUnder5GlobalNoFace = 12110,
  KITAPGlobalNoFace = 12111,
  CCCDGlobalNoFace = 12112,
  CMNDGlobalNoFace = 12113,
  MyPRGlobalNoFace = 12114,
  MyKADGlobalNoFace = 12115,
  AadhaarGlobalNoFace = 12116,
  DriversLicenseFrontFace = 13001,
  MyNumberCardFrontFace = 13002,
  ResidenceCardFrontFace = 13003,
  PassportFrontFace = 13004,
  SpecialPermanentResidentCertificateFrontFace = 13005,
  DrivingHistoryCertificateFrontFace = 13006,
  PassportAnyIssuanceDateFrontFace = 13016,
  ForeignPassportFrontFace = 13020,
  StudentIDCardFrontFace = 13018,
  BasicResidentRegistrationCardFrontFace = 13017,
  StudentNotebookFrontFace = 13019,
  DriversLicenseFront = 14001,
  MyNumberCardFront = 14002,
  ResidenceCardFront = 14003,
  PassportFront = 14004,
  SpecialPermanentResidentCertificateFront = 14005,
  DrivingHistoryCertificateFront = 14006,
  HealthInsuranceCardFront = 14007,
  PassportAnyIssuanceDateFront = 14016,
  ForeignPassportFront = 14020,
  PhysicalDisabilityCertificateBookFront = 14008,
  PhysicalDisabilityCertificateCardFront = 14009,
  SpecialEducationBookFront = 14010,
  SpecialEducationCardFront = 14011,
  MentalDisabilityCertificateBookFront = 14012,
  MentalDisabilityCertificateCardFront = 14013,
  PensionBookFront = 14014,
  BasicPensionNumberNotificationFront = 14015,
  BasicResidentRegistrationCardFront = 14017,
  StudentIDCardFront = 14018,
  StudentNotebookFront = 14019,
  EmployeeIDCardFront = 14021,
  MotherAndBabyNotebookFront = 14024,
  CertificateOfResidenceFront = 14025,
  CertificateOfFamilyRegisterFront = 14026,
  CertificateOfIndividualRecordsFront = 14027,
  DriversLicenseFrontBackFace = 15001,
  MyNumberCardFrontBackFace = 15002,
  ResidenceCardFrontBackFace = 15003,
  PassportFrontBackFace = 15004,
  SpecialPermanentResidentCertificateFrontBackFace = 15005,
  DrivingHistoryCertificateFrontBackFace = 15006,
  PassportAnyIssuanceDateFrontBackFace = 15016,
  ForeignPassportFrontBackFace = 15020,
  StudentIDCardFrontBackFace = 15018,
  BasicResidentRegistrationCardFrontBackFace = 15017,
  StudentNotebookFrontBackFace = 15019,
  DriversLicenseFrontBack = 16001,
  MyNumberCardFrontBack = 16002,
  ResidenceCardFrontBack = 16003,
  PassportFrontBack = 16004,
  SpecialPermanentResidentCertificateFrontBack = 16005,
  DrivingHistoryCertificateFrontBack = 16006,
  HealthInsuranceCardFrontBack = 16007,
  PassportAnyIssuanceDateFrontBack = 16016,
  ForeignPassportFrontBack = 16020,
  PhysicalDisabilityCertificateBookFrontBack = 16008,
  PhysicalDisabilityCertificateCardFrontBack = 16009,
  SpecialEducationBookFrontBack = 16010,
  SpecialEducationCardFrontBack = 16011,
  MentalDisabilityCertificateBookFrontBack = 16012,
  MentalDisabilityCertificateCardFrontBack = 16013,
  PensionBookFrontBack = 16014,
  BasicPensionNumberNotificationFrontBack = 16015,
  BasicResidentRegistrationCardFrontBack = 16017,
  StudentIDCardFrontBack = 16018,
  StudentNotebookFrontBack = 16019,
  EmployeeIDCardFrontBack = 16021,
  MotherAndBabyNotebookFrontBack = 16024,
  CertificateOfResidenceFrontBack = 16025,
  CertificateOfFamilyRegisterFrontBack = 16026,
  CertificateOfIndividualRecordsFrontBack = 16027
}

export default IdDocType;
